export var ShapeRadius;
(function (ShapeRadius) {
  ShapeRadius["CONTROL"] = "4px";
  ShapeRadius["SECTION"] = "8px";
  ShapeRadius["DIALOG"] = "8px";
})(ShapeRadius || (ShapeRadius = {}));